import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TermsAcceptanceModal from './TermsAcceptanceModal';
import HandlePickerModal from './HandlePickerModal';

const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [authComplete, setAuthComplete] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      const isAuthenticated = await checkAuth();
      setAuthComplete(true);
      if (!isAuthenticated) {
        navigate('/', { replace: true });
      }
    };

    if (!authComplete && !user) {
      verifyAuth();
    } else if (user) {
      setAuthComplete(true);
    }
  }, [checkAuth, navigate, user, loading, authComplete]);

  // Show spinner while checking auth
  if (!authComplete || loading || !user) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sage mx-auto"></div>
          <p className="mt-4 text-charcoal">Loading...</p>
        </div>
      </div>
    );
  }

  // Step 1: Terms acceptance
  if (!user.tos_accepted) {
    return (
      <TermsAcceptanceModal
        onAccepted={() => {
          checkAuth();
        }}
      />
    );
  }

  // Step 2: Handle selection (after terms)
  if (!user.handle) {
    return (
      <HandlePickerModal
        onHandleSet={() => {
          checkAuth();
        }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
